<template>
  <v-container id="modeShareContainer" fill-height  style="max-width:100%;">
    <v-row style="height:100%;">
      <v-col style="height:100%;padding:0;">
        <v-card flat class="card-style">
          <div class="card-style-title">
            Modal share of cycling journeys
            <div class="btnCont">
              <iframe-modal :id="id" :src="src" :width="850" :height="900" />
              <v-btn
              depressed
                rounded
                color="#00486b"
                style="color:#fff"
                width="7em"
                :href="mapDatasetUrls"
                target="_blank"
              >
                Data
              </v-btn>
            </div>
          </div>
          <v-container style="margin:10px;max-width:100%;">
            <v-container v-if="overlay">
              <v-overlay :absolute="true" :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
            </v-container>
            <v-container v-if="!overlay" class="contentHolder">
              <v-row>
                <v-col cols="12">
                  <div class="description">
                    <p>
                      Percentage of total journeys,
                      work journeys, and journeys less than 5 miles made by bike
                    </p>
                    <p class="source">
                      Data Source:
                      <a
                        target="_blank"
                        href="https://www.transport.gov.scot/publication/transport-and-travel-in-scotland-2019-results-from-the-scottish-household-survey/table-sum1-summary-of-scottish-household-survey-results/"
                      >Transport and Travel in Scotland:
                      Results from the Scottish Household Survey
                      </a>
                    </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <trendChart :colors="colors" :id="id" :data="results" />
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import trendChart from '@/components/trendChart.vue';
import iframeModal from '@/components/iframeModal.vue';

export default {
  components: {
    trendChart,
    iframeModal,
  },
  data() {
    return {
      results: [],
      overlay: true,
      colors: ['#143c6a', '#ed6d91', '#fdc300'],
      value: 1.5,
      id: 'modeshare',
      src: 'modeshare',
    };
  },
  computed: {
    ...mapGetters(['compositeDataset']),
    mapDatasetUrls() {
      let d = null;
      if (this.compositeDataset && this.compositeDataset.modeshareDataset) {
        d = this.compositeDataset.modeshareDataset.dataset;
        this.content(this.compositeDataset.modeshareDataset.apiResource);
      } else {
        console.error('No API Resource: ( modeshareDataset )');
      }
      return d;
    },
  },
  methods: {
    async content(resource) {
      const query = 'sort(+Year)';
      const params = { datasetGUID: resource, query };
      const newResults = await this.$store.dispatch('fetchData', params);
      // const newResults = await this.$store.dispatch("fetchData", params);
      this.results = newResults.data;
      this.overlay = false;
      // const newResults = await this.$store.dispatch("fetchData", resource);
      // this.results = newResults.data;
      // let highest = null;
      // this.results.forEach((result, index) => {
      //   const val = parseFloat(result.Value);
      //   if (highest === null || val > highest.value) highest = { value: val, index };
      // });
      // this.results.splice(highest.index, 1);
      // this.value = highest.value;
      // this.overlay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#modeShareContainer {
  font-size: 16px;
  max-width: 100%;
  .card-style {
    padding: 2em;
    width: 100%;
    height: 100%;
  }
}
.donutCnt {
  font-size: 1em;
  width: 15em;
  margin: auto;
}
.desc {
  font-size: 1.3em;
  font-weight: bold;
  text-align: center;
}
.description {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  p {
    font-size: 1em;
    font-weight: bold;
  }
  .source {
    font-size: 0.8em;
    font-style: italic;
    font-weight: bold;
  }
}
span {
  font-weight: bold;
  font-size: 0.9em;
  font-style: italic;
}
// @media (min-width: 650px) {
//   .description {
//     display: flex;
//     height: 100%;
//     flex-direction: column;
//     justify-content: center;
//     p {
//       font-size: 1.2em;
//       font-weight: bold;
//     }
//     .contentHolder {
//     margin: 10px;
//     max-width: 100%;
//   }
//   }
// }
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .description {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    p {
      font-size: 1.2em;
      font-weight: bold;
    }
    .contentHolder {
      margin: 10px;
      max-width: 100%;
    }
  }
}
</style>
